__turbopack_context__.v({
  "blocksBackgroundColor": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__blocksBackgroundColor",
  "blocksFontColor": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__blocksFontColor",
  "buttons": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__buttons",
  "container": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__container",
  "locationSearch": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__locationSearch",
  "locationSearchDisplay": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__locationSearchDisplay",
  "loginButton": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__loginButton",
  "loginDropDownMenu": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__loginDropDownMenu",
  "searchBar": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__searchBar",
  "secondaryNavBackgroundColor": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__secondaryNavBackgroundColor",
  "tagify": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__tagify",
  "themeBackgroundColor": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__themeBackgroundColor",
  "themeFontColor": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__themeFontColor",
  "themeFontFamily": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__themeFontFamily",
  "titleAndLocationSearch": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__titleAndLocationSearch",
  "topNavLogo": "CleverFeedLocationSearchBar-module-scss-module__WEUPkG__topNavLogo",
});
